import en from "./en";
import ja from "./ja";

const preview = {
  en,
  ja
};
export default preview;